import styled, { css } from 'styled-components';

interface IPropsInput {
  error: boolean;
}
interface IPropsContainer {
  sizeDisplay: 'lg' | 'sm' | 'md' | 'perso' | 'none';
  haveMargin: boolean;
}

export const Icon = styled.div`
  position: absolute;
  right: 10px;
  top: 33%;
  color: ${({ theme }) => theme.colors.orange.primary};
  width: 18px;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const IconCreditCard = styled.div`
  position: absolute;
  right: 10px;
  top: 10%;
  color: ${({ theme }) => theme.colors.orange.primary};
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Container = styled.div<IPropsContainer>`
  position: relative;

  ${(props) =>
    props.sizeDisplay === 'lg'
      ? css`
          width: 100%;
        `
      : props.sizeDisplay === 'md'
      ? css`
          width: calc(100% / 2 - 8px);
        `
      : props.sizeDisplay === 'none'
      ? ''
      : props.sizeDisplay === 'perso'
      ? css`
          width: 29.5%;
        `
      : css`
          width: calc(100% / 3 - 11px);
        `
    }

    
    ${(props) =>
      props.haveMargin === true ? css`
        margin: 0 1.8% 0 1.8%;
      ` : ''
    }
`;

export const Label = styled.label`
  color: #424242;
`

export const Input = styled.input<IPropsInput>`
  border: 1px solid
    ${({ theme, error }) =>
      !error ? theme.colors.gray[400] : theme.colors.attention};
  border-radius: 8px;

  color: ${({ theme, error }) => error && theme.colors.attention};

  padding: 12px 16px;
  height: 48px;

  font-weight: 400;
  font-size: 12px;

  outline: none;

  width: 100%;
`;

export const Error = styled.div`
  position: absolute;
  margin: 0;
  line-height: 100%;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.attention} !important;
  bottom: -16px;
  height: fit-content;
  left: 16px;
  height: fit-content;
`;

export const InputLabel = styled.label`
  position: absolute !important;
  top: -6px;
  left: 16px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.gray[500]};
  background-color: ${({ theme }) => theme.colors.white};
  animation: smooth;
`;
